export var SensitivityLevel;
(function (SensitivityLevel) {
    SensitivityLevel["SENSITIVITY_LEVEL_PUBLIC"] = "PUBLIC";
    SensitivityLevel["SENSITIVITY_LEVEL_INTERNAL"] = "INTERNAL";
    SensitivityLevel["SENSITIVITY_LEVEL_CONFIDENTIAL"] = "CONFIDENTIAL";
    SensitivityLevel["SENSITIVITY_LEVEL_HIGH_RISK_CONFIDENTIAL"] = "HIGH_RISK_CONFIDENTIAL";
})(SensitivityLevel || (SensitivityLevel = {}));
